import { format, formatDistance } from 'date-fns';

const safelyFormatDate = (time: any) => {
  try {
    const date = new Date(time)
    if (date.toString() === 'Invalid Date') return null;
    return date
  } catch (e) {
    return null;
  }
}

export const safelyFormatDistance = (time: any) => {
  const date = safelyFormatDate(time);
  if (!date) return 'unknown';
  return formatDistance(date, new Date(), { addSuffix: true });
}

export const formatDate = (time: any) => {
  const date = safelyFormatDate(time);
  if (!date) return 'unknown';
  return format(date, 'yyyy-MM-dd HH:mm')
}

export const formatDateday = (time: any) => {
  const date = safelyFormatDate(time);
  if (!date) return 'unknown';
  return format(date, 'yyyy-MM-dd')
}
